import { ApiError } from "go-core/api/types";
import { EMAIL_REGEX_PATTERN } from "go-core/utils/constants";
import { PayOrderData } from "../../../../../services/Api/Public/types";

const isTaxIdNoValid = (data: PayOrderData, sendInvoice: boolean) => {
	if (sendInvoice) {
		let taxIdNoValue = data.tax_id_no;

		if (!taxIdNoValue) return false;

		if (/[a-zA-Z]/.test(taxIdNoValue)) return false;

		taxIdNoValue = taxIdNoValue.replace(/-/g, "").replace(/\s/g, "");

		if (taxIdNoValue.length !== 10) return false;

		const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
		let sum = 0;

		for (let i = 0; i < weights.length; i++) {
			const digit = parseInt(taxIdNoValue.charAt(i), 10);
			if (isNaN(digit)) return false;
			sum += digit * weights[i];
		}

		const checksum = parseInt(taxIdNoValue.charAt(9), 10);
		if (isNaN(checksum)) return false;

		return sum % 11 === checksum;
	}

	return true;
};

const isEmailValid = (data: PayOrderData) => {
	const email = data.email;

	if (!email) return false;

	if (email.includes("..")) return false;
	if (email.startsWith(".")) return false;

	const ePattern = EMAIL_REGEX_PATTERN;
	if (!ePattern.test(email)) return false;

	const parts = email.split("@");
	if (parts.length !== 2) return false;

	const [localPart, domainPart] = parts;
	if (!localPart || !domainPart) return false;
	if (!domainPart.includes(".")) return false;

	return true;
};

export const validateOrderPaymentData = (
	data: PayOrderData,
	sendInvoice: boolean,
	setCustomFormErrors: React.Dispatch<React.SetStateAction<ApiError[]>>
) => {
	const newErrors: ApiError[] = [];

	if (!isTaxIdNoValid(data, sendInvoice)) {
		newErrors.push({
			field: "tax_id_no",
			code: "constraints.tax_id_number_correct",
			message: "tax_id_number_correct",
		});
	}

	if (!isEmailValid(data)) {
		newErrors.push({
			field: "email",
			code: "email.invalid",
			message: "invalid_email",
		});
	}

	setCustomFormErrors(newErrors);

	return newErrors.length === 0;
};
